module.exports = __webpack_public_path__ + "media/images/circle-bab91fe2012053541a17aae5c4cb138d.png";